import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { PlayerProvider } from "./context/PlayerContext";
import TitleScreen from "./pages/TitleScreen";
import Lobby from "./pages/Lobby";
import Duel from "./pages/Duel";
import Dashboard from "./pages/Dashboard";
import Leaderboard from "./pages/Leaderboard";
import CardDemo from "./pages/CardDemo";

function App() {
  return (
    <div className="App">
      <PlayerProvider>
        <BrowserRouter>
          <Toaster
            position="top-center"
            toastOptions={{
              style: {
                fontFamily: "Special Elite, monospace",
                background: "#f5ead4",
                border: "2px solid #5d3b00",
                color: "#452a00",
                borderRadius: 0,
              },
            }}
          />
          <Routes>
            <Route path="/" element={<TitleScreen />} />
            <Route path="/lobby" element={<Lobby />} />
            <Route path="/duel/:difficulty" element={<Duel />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/leaderboard" element={<Leaderboard />} />
            <Route path="/demo/card" element={<CardDemo />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </PlayerProvider>
    </div>
  );
}

export default App;
